/* eslint-disable array-callback-return */
import React, { useContext } from 'react';
import Player from '../PlayerList/Player';
import './Carousel.css';
import CurrentUserContext from '../../Contexts/userContexts'
import Modal from "../PopUp/Modal"
import DisplayInformation from "../PopUp/displayInformation";
import DisplayDisplayMessageDontAdd from "../PopUp/DisplayMessageDontAdd";

function SlideOne() {
    const { singlePlayer, show, setShow, setselect,  goalkeeper, setGoalkeeper, defender, setDefender, midfielder, setMidfielder, forward, setForward, setPlayerSelectState, setDisplaymessage, setDisplayMessageDontAdd  } = useContext(CurrentUserContext)

    let values = [51, 54, 32, 1]

    const displayPlayersOfWeek = []


    values.map(num => {
        singlePlayer.filter((el, index) => num === index).map(filteredPerson => (
            displayPlayersOfWeek.push(filteredPerson.player[0])
        ))
    })

    const toggleModal = (idPlayer) => {
        setShow(!show)
        setselect(idPlayer)
    }

    if (show) {
        document.body.classList.add('active-modal')
    } else {
        document.body.classList.remove('active-modal')

    }

    function onSelectCard(playerSelect) {
        if ((playerSelect.strPosition === 'Goalkeeper') && (goalkeeper.length === 0)) {
            setGoalkeeper([...goalkeeper, playerSelect])
            localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
            setPlayerSelectState(playerSelect.strPlayer)
            setDisplaymessage(true)
        }
       
        else if ((playerSelect.strPosition === "Right Back" || playerSelect.strPosition === "Full-back" || playerSelect.strPosition === "Centre Back" || playerSelect.strPosition === "Left Back" || playerSelect.strPosition === "Defender") && (defender.length <= 3)) {
            if(defender.length===0)
                {localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                setDefender([...defender, playerSelect])
                setPlayerSelectState(playerSelect.strPlayer)
                setDisplaymessage(true)
            }
             if(defender.length>0){

                    if(defender.includes(playerSelect)!==true){
                        localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                        setDefender([...defender, playerSelect])
                        setPlayerSelectState(playerSelect.strPlayer)
                        setDisplaymessage(true) 
                    }

                    else{
                        setDisplayMessageDontAdd(true)
                    }
            }}

        else if ((playerSelect.strPosition === "Midfielder" || playerSelect.strPosition === "Attacking Midfielder" || playerSelect.strPosition === "Centre Midfielder") && (midfielder.length <= 3)) {
            if(midfielder.length===0)
                {localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                setMidfielder([...midfielder, playerSelect])
                setPlayerSelectState(playerSelect.strPlayer)
                setDisplaymessage(true)
                }
            else if(midfielder.length>0){
                if(midfielder.includes(playerSelect)!==true){
                    localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                    setMidfielder([...midfielder, playerSelect])
                    setPlayerSelectState(playerSelect.strPlayer)
                    setDisplaymessage(true) 
                }
                else{
                    setDisplayMessageDontAdd(true)
                }
            }
        
        }
        else if ((playerSelect.strPosition === "Forward" || playerSelect.strPosition === "Winger" || playerSelect.strPosition === "Left Wing" || playerSelect.strPosition === "Right Wing") && (forward.length <= 1)) {
            if(forward.length===0)
                {localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                setForward([...forward, playerSelect])
                setPlayerSelectState(playerSelect.strPlayer)
                setDisplaymessage(true)
                }
            else if(forward.length>0){
                if(forward.includes(playerSelect)!==true){
                    localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                    setForward([...forward, playerSelect])
                    setPlayerSelectState(playerSelect.strPlayer)
                    setDisplaymessage(true) 
                }
                else{
                    setDisplayMessageDontAdd(true)
                }
            }
                
        }
        else{
            setDisplayMessageDontAdd(true)
        }
        toggleModal(playerSelect.idPlayer)
    }


    return (
        <div className="slideOne">
            <DisplayInformation/>
            <DisplayDisplayMessageDontAdd/>
            <h1>Cards of the week</h1>
            <div className="slideOnePlayers">
                {displayPlayersOfWeek.map(el => <Player  {...el}  key={el.idPlayer} toggleModal={toggleModal}/>)}
            </div>
            <div className='popupFirst'>
                <Modal onSelectCard={onSelectCard} />
            </div>
        </div>

    )
}

export default SlideOne